(function () {
  'use strict';

  var INTERVAL_MS = 3500;

  function initSlideshow(container) {
    var slides = Array.prototype.slice.call(container.querySelectorAll('.promo-slide'));
    if (slides.length < 2) return; // nothing to rotate

    var index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (index === -1) index = 0;

    setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, INTERVAL_MS);
  }

  function init() {
    var containers = document.querySelectorAll('.promo-card__media--slideshow');
    Array.prototype.forEach.call(containers, initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();